import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  defaultTitleColor: '#2a1e17'
} satisfies RecursivePartial<CMSConfig['accordion']>
